export const authorizationUrl = 'https://fedlogin.jnj.com/as/authorization.oauth2';
export const clientId = 'imedicalseacrh3';
export const client_secret = 'PHfT0mGqPN3HMol5MOnFIWmzgqK5pSWCvFJl8yRCvyDxaHCklQKENR76jFzSqEb4';
export const redirectUri = window.location.origin;
export const oauthServerUrl='https://fedlogin.jnj.com/';
export const scope='openid';

